import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import moment from 'moment';
import ExternalLink from '../../../../assets/subscriber/external-link.svg';
import Trash from '../../../../assets/allInvoice-assets/trash-2.svg';
import CustomTooltip from '../../utils/CustomTooltip';
import { classes } from './utils';

const organizationName = (params) => {
  const orgName = params?.data?.organization?.name;
  return (
    <Typography variant="body1" fontWeight={400}>
      {orgName !== undefined ? orgName : '-'}
    </Typography>
  );
};

const organizationAdminName = (params) => {
  const { data } = params;

  const fullName =
    data?.first_name !== undefined &&
    data?.first_name !== null &&
    data?.last_name !== undefined &&
    data?.last_name !== null
      ? `${data?.first_name} ${data?.last_name}`
      : null;

  return (
    <Typography variant="body1" fontWeight={400}>
      {fullName !== null ? fullName : '-'}
    </Typography>
  );
};

const organizationAdminPhoneNumber = (params) => {
  const phoneNumber = params?.data?.phone_no;

  return (
    <Typography variant="body1" fontWeight={400}>
      {phoneNumber !== undefined ? phoneNumber : '-'}
    </Typography>
  );
};

const organizationRegisteredDate = (params) => {
  const { value, data } = params;
  const formattedDate = data
    ? moment.utc(value).local().format('DD-MM-YYYY HH:mm:ss')
    : null;

  return (
    <Typography variant="body1" fontWeight={400}>
      {formattedDate || '-'}
    </Typography>
  );
};

const organizationNoOfCredits = (params) => {
  const { data } = params;
  const lastPayment = data?.organization;
  const remainingCredits = lastPayment?.used_credits;
  const totalCredits = lastPayment?.total_credits;
  return (
    <Typography variant="body1" fontWeight={400}>
      {`${remainingCredits || 0} of ${totalCredits || 0}`}
    </Typography>
  );
};

const organizationTotalAmount = (params) => {
  const { data } = params;
  const lastPayment = data?.organization?.payment[0];
  const totalAmount = lastPayment?.total_amount;

  return (
    <Typography variant="body1" fontWeight={400}>
      {totalAmount !== undefined ? `$ ${totalAmount}` : '-'}
    </Typography>
  );
};

const organizationAdminStatus = (params) => {
  const { data } = params;
  const isActive = data?.is_active;

  let status;
  if (isActive !== undefined) {
    status = isActive ? 'Active' : 'Inactive';
  } else {
    status = '-';
  }

  return (
    <Typography variant="body1" fontWeight={400}>
      {status}
    </Typography>
  );
};

const ResponsiveCell = (params) => {
  const { value } = params;

  return (
    <Typography variant="body1" fontWeight={400}>
      {value !== undefined ? value : '-'}
    </Typography>
  );
};

const ActionCell = (params) => {
  const { data } = params;
  const organizationId = data?.organization_id;
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/account-info/?tab=billingInfo&organizationId=${organizationId}`);
  };
  if (params?.data) {
    if (params?.data?.organization !== undefined) {
      return (
        <Grid>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={6}>
              <CustomTooltip title="View Subscribers Details">
                <Box
                  component="img"
                  src={ExternalLink}
                  alt="external-link"
                  className={classes.ActionIcons}
                  onClick={handleNavigate}
                />
              </CustomTooltip>
            </Grid>
            <Grid item xs={6}>
              <CustomTooltip title="Delete Organization">
                <Box
                  component="img"
                  src={Trash}
                  alt="delete"
                  className={classes.ActionIcons}
                />
              </CustomTooltip>
            </Grid>
          </Grid>
        </Grid>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const subscriberColumnDef = (
  gridSettingData,
  gridKey,
  customFilterValue,
  screenWidth,
) => {
  const isSmallScreen = screenWidth < 600;

  return [
    // {
    //   headerName: ' ',
    //   field: ' ',
    //   minWidth: 70,
    //   maxWidth: 70,
    //   headerComponent: 'HeaderCheckbox',
    //   checkboxSelection: true,
    //   sortable: false,
    //   resizable: false,
    //   pinned: 'left',
    //   lockPinned: true,
    //   lockPosition: true,
    // },
    {
      headerName: 'Organization Name',
      field: 'organization_name',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 200 : 250,
      maxWidth: isSmallScreen ? 300 : 350,
      pinned: isSmallScreen ? '' : 'left',
      cellRenderer: organizationName,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      hide: false,
    },
    {
      headerName: 'Admin Name',
      field: 'admin_name',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 200 : 250,
      cellRenderer: organizationAdminName,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Email',
      field: 'email',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 150 : 200,
      cellRenderer: ResponsiveCell,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Date',
      field: 'created_at',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 200 : 250,
      cellRenderer: organizationRegisteredDate,
      filter: 'agDateColumnFilter',
      type: 'date',
      suppressMenu: true,
      filterParams: {
        filterOptions: ['inRange'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
        comparator: (filterDate, cellValue) => {
          const cellDate = new Date(cellValue);
          if (cellDate < filterDate) return -1;
          if (cellDate > filterDate) return 1;
          return 0;
        },
      },
    },
    {
      headerName: 'Phone No.',
      field: 'phone',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      minWidth: isSmallScreen ? 100 : 125,
      maxWidth: isSmallScreen ? 150 : 200,
      cellRenderer: organizationAdminPhoneNumber,
    },
    {
      headerName: 'No. of Credits',
      field: 'no_of_credits',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 175 : 200,
      cellRenderer: organizationNoOfCredits,
    },
    {
      headerName: 'Price',
      field: 'price',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      minWidth: isSmallScreen ? 100 : 125,
      maxWidth: isSmallScreen ? 140 : 150,
      cellRenderer: organizationTotalAmount,
    },
    {
      headerName: 'Status',
      field: 'is_active',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 100 : 125,
      maxWidth: isSmallScreen ? 150 : 150,
      cellRenderer: organizationAdminStatus,
    },
    {
      headerName: ' ',
      field: ' ',
      headerComponent: 'ResponsiveSortingHeader',
      minWidth: isSmallScreen ? 90 : 115,
      cellRenderer: ActionCell,
    },
  ];
};

export default subscriberColumnDef;
